import axios from '@/utils/axios';
import { Config } from '@/models/config';
import { plainToClass } from 'class-transformer';

export class ConfigService {
  static getConfig(slug: string): Promise<Config> {
    return axios
      .get('config/', { params: { slug } })
      .then(({ data }) => plainToClass(Config, data));
  }
}
